import TextField from '@mui/material/TextField';
import * as React from 'react';
import {TextFieldProps} from '@mui/material/TextField/TextField';
import {Controller, useFormContext} from 'react-hook-form';
import InputAdornment from '@mui/material/InputAdornment/InputAdornment';
import {InputProps as StandardInputProps} from "@mui/material/Input/Input";
import {FilledInputProps, OutlinedInputProps} from "@mui/material";

export type MuiRfhTextFieldProps = {
  name: string,
  unit?: string;
} & Partial<Omit<TextFieldProps, 'onChange' | 'value' | 'name'>>;

export function MuiRhfTextField(props: MuiRfhTextFieldProps) {
  const {name, unit, required, label, helperText, ...rest} = props;
  const {control} = useFormContext<any>();

  let additionalProps: StandardInputProps['inputProps'] | FilledInputProps['inputProps'] | OutlinedInputProps['inputProps'] = props.inputProps;
  if (unit) {
    additionalProps = {
      ...additionalProps,
      endAdornment:
        <InputAdornment position="end">{unit}</InputAdornment>
    }
  }

  return (
    <Controller
      name={name}
      control={control}
      render={renderProps =>
        <TextField
          name={renderProps.field.name}
          label={label + (required ? ' *' : '')}
          onChange={renderProps.field.onChange}
          onBlur={renderProps.field.onBlur}
          value={renderProps.field.value === undefined ? '' : renderProps.field.value}
          error={!!renderProps.fieldState.error}
          helperText={renderProps.fieldState.error?.message || helperText}
          InputProps={additionalProps as any}
          {...rest}
        />
      }
    />
  );
}
